export const eur = (n) =>
  n.toLocaleString("it-IT", { style: "currency", currency: "EUR" });

export const eur2 = (n) =>
  n.toLocaleString("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export function unitPrice(product, qty) {
  let price = product.base_price;
  const tiers = [...(product.tiers || [])].sort((a, b) => a.min_qty - b.min_qty);
  for (const t of tiers) {
    if (qty >= t.min_qty) price = t.price;
  }
  return price;
}
